// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom components
// Assets
import React from 'react';
import { Link as NavLink } from 'react-router-dom';
import {
  IoMusicalNotes, IoWallet,
} from 'react-icons/io5';
import Card from './Card';

export default function NFT(props) {
  const {
    image, name, download, is_paid, video,
    onDelete,
  } = props;
  const textColor = useColorModeValue('navy.700', 'white');
  return (
    <Card p="20px">
      <Flex direction={{ base: 'column' }} justify="center">
        <Box mb={{ base: '20px', '2xl': '20px' }} position="relative">
          <Image
            src={image}
            w={{ base: '100%', '3xl': '100%' }}
            h={{ base: '100%', '3xl': '100%' }}
            borderRadius="20px"
          />
        </Box>
        <Flex flexDirection="column" justify="space-between" h="100%">
          <Flex
            justify="space-between"
            direction={{
              base: 'row',
              md: 'column',
              lg: 'row',
              xl: 'column',
              '2xl': 'row',
            }}
            mb="auto"
          >
            <Flex direction="column">
              <Text
                color={textColor}
                fontSize={{
                  base: 'xl',
                  md: 'lg',
                  lg: 'lg',
                  xl: 'lg',
                  '2xl': 'md',
                  '3xl': 'lg',
                }}
                mb="5px"
                fontWeight="bold"
                me="14px"
              >
                {name}
              </Text>

            </Flex>
            <Flex>
              {video?.is_audio && (
              <Icon
                transition="0.2s linear"
                w="20px"
                h="20px"
                as={IoMusicalNotes}
                color="brand.500"
              />
              )}
              {is_paid && (
              <Icon
                transition="0.2s linear"
                w="20px"
                h="20px"
                as={IoWallet}
                color="brand.500"
              />
              )}
            </Flex>
          </Flex>
          <Flex
            align="start"
            justify="space-between"
            direction={{
              base: 'row',
              md: 'column',
              lg: 'row',
              xl: 'column',
              '2xl': 'row',
            }}
            mt="25px"
          >
            <Link
              as={NavLink}
              to={download}
              mt={{
                base: '0px',
                md: '10px',
                lg: '0px',
                xl: '10px',
                '2xl': '0px',
              }}
            >
              <Button
                variant="darkBrand"
                color="white"
                fontSize="sm"
                fontWeight="500"
                borderRadius="70px"
                px="24px"
                py="5px"
              >
                View
              </Button>
            </Link>

            {onDelete && (
            <Button
              colorScheme="red"
              fontSize="sm"
              fontWeight="500"
              borderRadius="70px"
              px="24px"
              py="5px"
              onClick={onDelete}
            >
              Delete
            </Button>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
